(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('CommentDetailController', CommentDetailController);

    CommentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comment', 'Contract', 'Shipment', 'Invoice', 'Lot'];

    function CommentDetailController($scope, $rootScope, $stateParams, previousState, entity, Comment, Contract, Shipment, Invoice, Lot) {
        var vm = this;

        vm.comment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:commentUpdate', function(event, result) {
            vm.comment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
